module.exports = "<svg viewBox=\"0 0 14 19\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 6.5h-4v-6H4v6H0l7 7 7-7zm-14 9v2h14v-2H0z\" fill=\"#000\" fill-rule=\"evenodd\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/icon-download.svg
// module id = 643
// module chunks = 0